import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ImpersonateDocument } from './impersonate.generated';

export const useImpersonate = (options: ApiOptions<typeof ImpersonateDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(ImpersonateDocument, {
    ...useNotifications(ImpersonateDocument, {
      failure: t('api.users.impersonate_error'),
      success: t('api.users.impersonate_success'),
    }),
    ...options,
  });
};
